import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

export default function Team() {
    const profiles = [
            {
                name: "Joseph Casebeer",
                role: "Founder",
                image: "/images/team/joseph.webp",
                linkedin: "https://linkedin.com/in/joseph-casebeer/",
            },
            {
                name: "Paul Nam",
                role: "Software Developer",
                image: "/images/team/paul.webp",
                linkedin: "https://linkedin.com/in/paul-nam/",
            },
            {
                name: "Sakura Watanabe",
                role: "Graphics Designer",
                image: "/images/team/sakura.webp",
                linkedin: "https://linkedin.com/in/sakura-watanabe-/",
            },
            {
                name: "Emilio Ganchorre",
                role: "Marketer",
                image: "/images/team/emilio.jpg",
                linkedin: "https://www.linkedin.com/in/emiliaganchorre/",
            },

        ];
    return (
        <div className="flex flex-col w-full h-full items-center justify-center">
            <Header />
            <div className="flex flex-col w-[70%] md:w-[60%] lg:w-[45%] h-full items-top justify-start gap-y-[2rem] mt-[5rem]">
                <h1 className="font-bold text-2xl">Our Team</h1>
                
                <p className="w-[80%] lg:w-[50%]">The goal and mission of Takamori Robot is to provide affordable, modular, and customizable robotics kits for everyone.</p>
                
                {/* Team grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-[5rem] gap-x-[2rem]">
                {profiles.map((profile, index) => (
                    <div key={index} className="flex flex-row items-center space-x-4">
                        <img
                            src={profile.image}
                            alt={profile.name}
                            className="w-24 h-24 rounded-full object-cover"
                        />
                        <div className="flex flex-col">
                            <p className="font-semibold">{profile.name}</p>
                            <p className="text-sm text-gray-500">{profile.role}</p>
                            <a
                                href={profile.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline text-sm"
                            >
                                LinkedIn
                            </a>
                        </div>
                    </div>
                ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}